// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang';
import rum from './tool/rum';
import Tracker from './tool/ta';
import store from './store'
import axios from 'axios'


Vue.use(Tracker, {
  appId: process.env.NODE_ENV == 'production' ? 'cca3886d5c74414fa5df24c07ff9328e' : 'cca3886d5c74414fa5df24c07ff9328e',
  zoneOffset: 0
})
Vue.use(rum, {
  app_id: process.env.NODE_ENV == 'production' ? 'web_vip_mall.global.prod':'web_vip_mall.global.sandbox',
  env: process.env.NODE_ENV
})


console.log('update1');

axios.defaults.withCredentials = true
//axios.defaults.headers['x-requested-with'] = 'new'

Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
  console.error(err);
  vm.$rum.errorReport(err, vm, info)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
  mounted() {
    console.log(i18n, i18n.messages[i18n.locale].meta, 'meta');
    const meta = i18n.messages[i18n.locale].meta;
    // 初始化时设置 meta 信息
    this.updateMetaTags(meta);
  },
  watch: {
    // 监听语言切换时更新 meta 信息
    "$i18n.locale"(newLocale) {
      const meta = i18n.messages[i18n.locale].meta;
      this.updateMetaTags(meta);
    }
  },
  methods: {
    updateMetaTags(meta) {
      if (!meta) return;

      // 更新 title
      document.title = meta.title;

      // 更新 description
      this.setMetaTag("description", meta.description);

      // 更新 keywords
      this.setMetaTag("keywords", meta.keywords);
    },
    setMetaTag(name, content) {
      if (!content) return;
      let metaTag = document.querySelector(`meta[name='${name}']`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.name = name;
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute("content", content);
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js